import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { getTopicSessions } from "../../helpers/api/api";

export const GET_TOPIC_SESSIONS = "GET_TOPIC_SESSIONS";
export const callGetTopicSessions = (inputs) => {
  const meta = {
    endpoint: (params) => getTopicSessions(params),
    inputs,
    action: GET_TOPIC_SESSIONS,
    messages: {
      id: "getTopicSessions",
      failure: "Could not get Topic Sessions.",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  result: [],
};

const messages = {
  loadFailed: "Could not load topic sessions.",
};

const saveTopicSessions = (state, action) => {
  return R.assoc("result", action.result, state);
};

export default reducer(
  initialState,
  GET_TOPIC_SESSIONS,
  saveTopicSessions,
  messages.loadFailed
);
